import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const FinalCTA = () => {
  const { t } = useLanguage();
  const TIDYCAL_URL = "https://tidycal.com/mathiasdeppe/free-15-minute-growth-review";

  return (
    <section className="py-32 px-6 bg-zinc-950 relative overflow-hidden">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-[300px] bg-orange-500/5 blur-[100px] pointer-events-none" />
      
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <motion.h2 
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="text-4xl md:text-6xl font-black text-white mb-8 tracking-tighter"
        >
          {t.finalCta.h2}
        </motion.h2>
        
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-lg md:text-xl text-zinc-400 mb-12 leading-relaxed"
        >
          {t.finalCta.p}
        </motion.p>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="flex flex-col items-center"
        >
          <a 
            href={TIDYCAL_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="px-10 py-5 text-xl font-black text-zinc-950 bg-white rounded-full hover:bg-orange-500 hover:text-white transition-all duration-300 transform hover:scale-105 shadow-2xl text-center"
          >
            {t.finalCta.cta}
          </a>
          
          <p className="mt-6 text-zinc-500 text-sm italic max-w-md">
            "{t.finalCta.subtext}"
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;